import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    templateUrl: "./clare-controller-input-confirmation.component.html",
})
export class ClareControllerInputConfirmationComponent {
    constructor(public dialogRef: MatDialogRef<ClareControllerInputConfirmationComponent>) {}

    onNoClick(): void {
        console.log("onNoClick");
        this.dialogRef.close();
    }
}
